import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import checkTokenValidity from "../utils/tokenVerification";
import Spinner from "../components/spinner";

const PublicRoute = ({ element: Component, ...rest }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [event, setEvent] = useState(null);

  useEffect(() => {
    const init = async () => {
      const isValid = await checkTokenValidity();
      setIsAuthenticated(isValid);

      const storedEvent = localStorage.getItem("event");
      setEvent(storedEvent);
    };

    init();
  }, []);

  if (isAuthenticated === null) {
    return (
      <div className="flex h-screen justify-center items-center">
        <Spinner message="Loading..." />
      </div>
    );
  }

  if (isAuthenticated && event) {
    return <Navigate to={`/event/${event}/dashboard`} replace />;
  }

  return <Component {...rest} />;
};

export default PublicRoute;
